module.exports = __webpack_public_path__ + "img/d3372c3.png";